export const useLogoutUserQuery = () => {
  const trigger = async () => ({ data: { message: 'Logged out (static mode)' } });
  return { refetch: trigger };
};
